<template>
	<div><div id="breathData"></div></div>
</template>

<script>
export default {
	data() {
		return {
			// websock: null,
			breathList: []
		};
	},
	created() {
		this.initWebSocket();
	},
	// destroyed() {
	// 	this.websock.close() //离开路由之后断开websocket连接
	// },
	mounted() {
		this.getEcharts();
	},
	methods: {
		getEcharts() {
			var that = this;
			var breathData = that.$echarts.init(document.getElementById('breathData'));
			var xAxisData = [];
			var yAxisData = [];
			for (var i = 500; i > 0; i--) {
				xAxisData.push(i + '秒前');
			}
			for (i = 1; i < 501; i++) {
				if (that.breathList.length > 0) {
					that.breathList.map(val => {
						yAxisData.push(val);
					});
				} else {
					yAxisData.push(0);
				}
			}
			var breathDataOption = {
				animation: false,
				title: {
					text: '呼吸（次/分钟）'
					/*,left:"110px"*/
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				grid: {
					left: 50,
					right: 15
				},
				xAxis: {
					boundaryGap: false,
					data: xAxisData
				},
				yAxis: {
					boundaryGap: false
				},
				series: {
					symbol: 'none' /*去掉小圆点*/,
					name: '当前呼吸值',
					type: 'line',
					itemStyle: {
						normal: {
							lineStyle: {
								width: 2, //折线宽度
								color: '#87AFE7' //折线颜色
							}
						}
					},
					data: yAxisData
				}
			};

			breathData.setOption(breathDataOption);
			window.onresize = breathData.resize();
			setInterval(function() {
				if (that.breathList.length > 0) {
					that.breathList.map(val => {
						yAxisData.push(val);
					});
				} else {
					yAxisData.push(0);
				}
				yAxisData.shift();
				breathData.setOption(breathDataOption);
				// 让echart随着浏览器的窗口变化
				window.onresize = breathData.resize();
			}, 100);
		},
		initWebSocket() {
			//初始化weosocket
			const wsuri = 'ws://121.46.26.109:8060/webSocketServer';
			var websock = new WebSocket(wsuri);
			this.breathList = [-1, -21, -10, 0, 2, 1, 21, 11, 20, 10, 20];
			websock.onmessage = this.websocketonmessage;
			websock.onerror = this.websocketonerror;
		},
		websocketonerror() {
			//连接建立失败重连
			this.initWebSocket();
		},
		websocketonmessage(e) {
			//数据接收
			window.console.log(e);
			// const redata = JSON.parse(e.data);
		}
	}
};
</script>

<style scoped="scoped">
#breathData {
	height: 300px;
}
</style>
